document.addEventListener('DOMContentLoaded', () => {
    const US_STATES = [
        "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado",
        "Connecticut", "Delaware", "Florida", "Georgia", "Hawaii", "Idaho",
        "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana",
        "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota",
        "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada",
        "New Hampshire", "New Jersey", "New Mexico", "New York",
        "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon",
        "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota",
        "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington",
        "West Virginia", "Wisconsin", "Wyoming"
    ];

    const modalOverlay = document.getElementById('ussrModalOverlay');
    const modalForm = document.getElementById('ussrModalForm');
    const withAgeSubtitle = document.querySelector('.ussr-modal__subtitle.with__age');
    const withoutAgeSubtitle = document.querySelector('.ussr-modal__subtitle.without__age');
    const ageGroup = document.getElementById('ussrAgeGroup');
    const ageCheckbox = document.getElementById('ussrAgeCheckbox');
    const ageError = document.getElementById('ussrAgeError');

    const headerTrigger = document.getElementById('ussrTrigger');
    const headerStateText = document.getElementById('ussrCurrentStateText');
    const headerForm = document.getElementById('ussrHeaderForm');
    const ussrSelector = document.querySelector('.ussr-selector__trigger');
    const ussrSelectorCard = document.querySelector('.ussr-selector__card');

    if (ussrSelector && ussrSelectorCard) {
        let isHovering = false;

        ussrSelector.addEventListener('mouseenter', () => {
            isHovering = true;
            ussrSelectorCard.classList.add('active');
        });

        ussrSelector.addEventListener('mouseleave', () => {
            isHovering = false;
            setTimeout(() => {
                if (!isHovering && !ussrSelectorCard.matches(':hover')) {
                    ussrSelectorCard.classList.remove('active');
                }
            }, 100);
        });

        ussrSelectorCard.addEventListener('mouseenter', () => {
            isHovering = true;
        });

        ussrSelectorCard.addEventListener('mouseleave', () => {
            isHovering = false;
            ussrSelectorCard.classList.remove('active');
        });

        document.addEventListener('click', (event) => { 
            if (!ussrSelector.contains(event.target) && !ussrSelectorCard.contains(event.target)) {
                ussrSelectorCard.classList.remove('active');
            }
        });
    }

    // Helper: Read state cookie
    function getCookieState() {
        const cookieMatch = document.cookie.match(/(?:^|; )ussr_state=([^;]*)/);
        return cookieMatch ? decodeURIComponent(cookieMatch[1]) : null;
    }

    function updateHeaderLabel(state) {
        if (headerStateText) {
            headerStateText.textContent = state;
        }
    }

    function updateHeaderInputValue(state) {
        const input = document.getElementById('ussrHeaderInput');
        if (input) {
            input.value = state;
        }
    }

    function enableAddToCart() { 
        const styleTag = document.getElementById('disable-atc-style'); 
        if (styleTag) { 
            styleTag.remove(); 
        } 
    }

    // Isolated Pills UI Updating Function
    function updatePillsUI(newState) {
        if (!newState) return;

        // Code for card pills
        const productPills = document.querySelectorAll('.ussr-pill__select.card');
        productPills.forEach(pill => {
            const allowedAttr = pill.getAttribute('data-allowed-states');
            if (!allowedAttr) return;
            const allowedStates = allowedAttr.split(',').map(s => s.trim());
            if (allowedStates.includes(newState)) {
                pill.classList.remove('ussr-pill__select--disabled');
                pill.innerHTML = `
                    <svg class="rg-svg-icon rg-svg-icon--available" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    Ships to <span class="ussr-pill_select__state">${newState}</span>
                `;
            } else {
                pill.classList.add('ussr-pill__select--disabled');
                pill.innerHTML = `
                    <svg class="rg-svg-icon rg-svg-icon--unavailable" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                    Doesn't ship to <span class="ussr-pill_select__state">${newState}</span>
                `;
            }
        });

        // Code for PDP pills
        const pdpPills = document.querySelectorAll('.ussr-pill__select.pdp');
        if (pdpPills.length > 0) {
            let pdpNotAllowed = false; 
            pdpPills.forEach(pill => {
                const allowedAttr = pill.getAttribute('data-allowed-states');
                if (!allowedAttr) return;
                const allowedStates = allowedAttr.split(',').map(s => s.trim());
                if (allowedStates.includes(newState)) {
                    pill.classList.remove('ussr-pill__select--disabled');
                    pill.innerHTML = `
                        <svg class="rg-svg-icon rg-svg-icon--available" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                        Ships to <span class="ussr-pill_select__state">${newState}</span>
                    `;
                    if (pill.getAttribute('data-state-disabled')) pill.removeAttribute('data-state-disabled');
                } else {
                    pill.classList.add('ussr-pill__select--disabled');
                    pill.innerHTML = `
                        <svg class="rg-svg-icon rg-svg-icon--unavailable" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                        Doesn't ship to <span class="ussr-pill_select__state">${newState}</span> 
                    `;
                    pill.setAttribute('data-state-disabled', 'true');
                    const isVisible = pill.getClientRects().length > 0;
                    if (isVisible) pdpNotAllowed = true; 
                }  
            });

            const atcButton = document.querySelector('.summary-item.add-to-cart');
            if (atcButton) {
                if (pdpNotAllowed) { 
                    atcButton.style.pointerEvents = 'none';
                    atcButton.style.opacity = '0.5';
                } else {
                    atcButton.style.pointerEvents = 'auto';
                    atcButton.style.opacity = '1';
                }
            }
        }

        // Code for Cart pills
        const cartPills = document.querySelectorAll('.ussr-pill__select.cart');
        let cartNotAllowed = false;
        cartPills.forEach(pill => {
            const allowedAttr = pill.getAttribute('data-allowed-states');
            if (!allowedAttr) return;
            const allowedStates = allowedAttr.split(',').map(s => s.trim());
            if (allowedStates.includes(newState)) {
                pill.classList.remove('ussr-pill__select--disabled');
                pill.innerHTML = `
                    <svg class="rg-svg-icon rg-svg-icon--available" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    Ships to <span class="ussr-pill_select__state">${newState}</span>
                `;
                if (pill.getAttribute('data-state-disabled')) pill.removeAttribute('data-state-disabled');
            } else {
                pill.classList.add('ussr-pill__select--disabled');
                pill.innerHTML = `
                    <svg class="rg-svg-icon rg-svg-icon--unavailable" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                    Doesn't ship to <span class="ussr-pill_select__state">${newState}</span>
                `;
                cartNotAllowed = true;
                pill.setAttribute('data-state-disabled', 'true');
            }
        });

        if (cartNotAllowed) {
            document.querySelectorAll('.us-cart-checkout-button').forEach(button => {
                button.style.pointerEvents = 'none';
                button.style.opacity = '0.5'; 
            });
        } else {
            document.querySelectorAll('.us-cart-checkout-button').forEach(button => {
                button.style.pointerEvents = 'auto';
                button.style.opacity = '1'; 
            });
            enableAddToCart();
        }
    }

    // Read initial state
    const isAgeVerified = localStorage.getItem('age-verified') === 'true';
    const localState = localStorage.getItem('ussr-state');
    const cookieState = getCookieState();
    const liquidCartState = window.ShopifyCartState || null;

    const savedState = cookieState || localState || liquidCartState || '';

    if (savedState) {
        localStorage.setItem('ussr-state', savedState);
        updateHeaderLabel(savedState);
        updateHeaderInputValue(savedState);
        updatePillsUI(savedState); // Initial UI render
    }

    // Modal display rules
    if (modalOverlay) {
        if (!isAgeVerified && !savedState) {
            modalOverlay.classList.remove('ussr-modal-overlay--hidden');
        } else if (!isAgeVerified) {
            modalOverlay.classList.remove('ussr-modal-overlay--hidden');
        } else if (isAgeVerified && !savedState) {
            modalOverlay.classList.remove('ussr-modal-overlay--hidden');
            if (ageGroup) ageGroup.classList.add('ussr-modal__field-group--hidden');
            if (withoutAgeSubtitle) withoutAgeSubtitle.style.display = 'block';
            if (withAgeSubtitle) withAgeSubtitle.style.display = 'none';
        }
    }

    async function setShippingState(newState) {
        const previousState = localStorage.getItem('ussr-state');
        
        localStorage.setItem('ussr-state', newState);
        document.cookie = `ussr_state=${encodeURIComponent(newState)}; path=/; max-age=31536000; SameSite=Lax`;
        
        updateHeaderLabel(newState);

        try {
            await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    attributes: {
                        'selectedState': newState,
                        '__selectedState': newState
                    }
                })
            });
        } catch (error) {
            console.error('Error updating cart attributes via Ajax:', error);
        }

        if (previousState !== newState) {
            document.dispatchEvent(new CustomEvent('state:changed', {
                detail: { state: newState },
                bubbles: true
            }));
        }
    }

    // Global listener for state updates
    document.addEventListener('state:changed', (event) => {
        updatePillsUI(event.detail.state);
    });

    // Handle Browser Back / Forward Navigation from Cache
    window.addEventListener('pageshow', async (event) => {
        if (event.persisted) {
            const freshCookieState = getCookieState();
            let freshCartState = null;

            try {
                const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { cache: 'no-store' });
                if (res.ok) {
                    const cart = await res.json();
                    freshCartState = cart.attributes ? (cart.attributes['selectedState'] || cart.attributes['__selectedState']) : null;
                }
            } catch (err) {
                console.error('Error fetching cart state on pageshow:', err);
            }

            const activeState = freshCartState || freshCookieState || localStorage.getItem('ussr-state');

            if (activeState) {
                localStorage.setItem('ussr-state', activeState);
                updateHeaderLabel(activeState);
                updateHeaderInputValue(activeState);

                document.querySelectorAll('.ussr-state-input').forEach(input => {
                    input.value = activeState;
                });

                // Directly trigger pill UI rendering when restoring page from back-forward cache
                updatePillsUI(activeState);

                document.dispatchEvent(new CustomEvent('state:changed', {
                    detail: { state: activeState },
                    bubbles: true
                }));
            }
        }
    });

    // Dropdown input logic
    document.querySelectorAll('.ussr-state-input').forEach(input => {
        const wrapper = input.closest('.ussr-modal__input-wrapper, .ussr-selector__input-wrapper');
        if (!wrapper) return;

        const dropdown = wrapper.querySelector('.ussr-state-dropdown');
        const fieldGroup = input.closest('.ussr-modal__field-group, .ussr-selector__field-group');
        const errorMsg = fieldGroup ? fieldGroup.querySelector('.ussr-state-error') : null;
        const arrow = wrapper.querySelector('.ussr-modal__arrow-btn, .ussr-selector__arrow-btn');

        if (arrow) { 
            arrow.style.pointerEvents = 'auto';
            arrow.style.cursor = 'pointer';

            arrow.addEventListener('click', (e) => {
                e.stopPropagation();
                
                const isOpen = dropdown.classList.contains('ussr-state-dropdown--visible');

                if (isOpen) {
                    dropdown.classList.remove('ussr-state-dropdown--visible');
                } else {
                    const isExactMatch = US_STATES.some(s => s.toLowerCase() === input.value.trim().toLowerCase());
                    renderOptions(isExactMatch ? '' : input.value);
                    dropdown.classList.add('ussr-state-dropdown--visible'); 
                }
            });
        }

        function renderOptions(filterText = '') {
            dropdown.innerHTML = ''; 

            const filtered = US_STATES.filter(s => s.toLowerCase().includes(filterText.toLowerCase().trim()));

            if (filtered.length === 0) {
                dropdown.innerHTML = `<div class="ussr-dropdown-empty">No matching state found</div>`;
                return;
            }

            filtered.forEach(state => {
                const item = document.createElement('button');
                item.type = 'button';
                item.className = 'ussr-dropdown-item';
                item.textContent = state; 

                item.addEventListener('mousedown', (e) => {
                    e.preventDefault();
                    selectState(state);
                });

                item.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        selectState(state);
                    }
                });

                dropdown.appendChild(item);
            });
        }

        function selectState(state) {
            input.value = state;
            dropdown.classList.remove('ussr-state-dropdown--visible');
            if (errorMsg) errorMsg.classList.remove('ussr-error--visible');
        }

        input.addEventListener('focus', () => { 
            const isExactMatch = US_STATES.some(s => s.toLowerCase() === input.value.trim().toLowerCase());
            renderOptions(isExactMatch ? '' : input.value);
            dropdown.classList.add('ussr-state-dropdown--visible');
        });

        input.addEventListener('input', () => {
            renderOptions(input.value);
            dropdown.classList.add('ussr-state-dropdown--visible');
        }); 

        input.addEventListener('blur', (e) => { 
            const isFocusInsideDropdown = wrapper.contains(e.relatedTarget); 
            if (!isFocusInsideDropdown) {
                dropdown.classList.remove('ussr-state-dropdown--visible');
            }
        });
    });

    // Form Submissions
    if (modalForm) {
        modalForm.addEventListener('submit', (e) => {
            e.preventDefault();
            let isValid = true;

            const isAgeVisible = ageGroup && !ageGroup.classList.contains('ussr-modal__field-group--hidden');
            if (isAgeVisible && ageCheckbox && !ageCheckbox.checked) {
                if (ageError) ageError.classList.add('ussr-error--visible');
                isValid = false;
            } else if (ageError) {
                ageError.classList.remove('ussr-error--visible');
            }

            const input = document.getElementById('ussrModalInput');
            const errorMsg = modalForm.querySelector('.ussr-state-error');
            const matchedState = input ? US_STATES.find(s => s.toLowerCase() === input.value.trim().toLowerCase()) : null;

            if (!matchedState) {
                if (errorMsg) errorMsg.classList.add('ussr-error--visible');
                isValid = false;
            } else if (errorMsg) {
                errorMsg.classList.remove('ussr-error--visible');
            }

            if (isValid) {
                localStorage.setItem('age-verified', 'true');
                setShippingState(matchedState);
                if (modalOverlay) modalOverlay.classList.add('ussr-modal-overlay--hidden');
            }

            updateHeaderInputValue(matchedState);
        });
    }

    if (headerTrigger && headerForm) {
        headerForm.addEventListener('submit', (e) => {
            e.preventDefault();
            const input = document.getElementById('ussrHeaderInput');
            const errorMsg = headerForm.querySelector('.ussr-state-error');
            const matchedState = input ? US_STATES.find(s => s.toLowerCase() === input.value.trim().toLowerCase()) : null;

            if (!matchedState) {
                if (errorMsg) errorMsg.classList.add('ussr-error--visible');
                return;
            }

            if (errorMsg) errorMsg.classList.remove('ussr-error--visible');
            if (ussrSelectorCard) ussrSelectorCard.classList.remove('active');
            setShippingState(matchedState);
        });
    }

    // Cart removal handler
    document.addEventListener('state:cart-item-remove', (event) => {
        const stateDisabled = event.detail.stateDisabled;
        const varId = event.detail.varId;
        if (stateDisabled === 'true') {
            const cartPills = document.querySelectorAll('.ussr-pill__select.cart');
            let cartNotAllowed = false;
            cartPills.forEach(pill => {
                const dataStateDisabled = pill.getAttribute('data-state-disabled') === 'true';
                if (dataStateDisabled && parseInt(pill.getAttribute('data-variant-id')) !== varId) {
                    cartNotAllowed = true;
                }   
            });

            if (cartNotAllowed) {
                document.querySelectorAll('.us-cart-checkout-button').forEach(button => {
                    button.style.pointerEvents = 'none';
                    button.style.opacity = '0.5'; 
                });
            } else {
                document.querySelectorAll('.us-cart-checkout-button').forEach(button => {
                    button.style.pointerEvents = 'auto';
                    button.style.opacity = '1'; 
                });
                enableAddToCart();
            }
        }
    });
});